// Tests whether this is a mobile device, not relying on breakpoints
export const isMobileDevice = () => {
  const hasTouch = navigator.maxTouchPoints > 0;

  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
  const isMobileUA = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);

  return hasTouch && isMobileUA;
};
